import React from 'react';
import moment from 'moment';
import * as ArchivedRenewalBucket from '../../../../constants/ArchivedRenewalBucket';
import { Assignment, AssignmentLate, Event } from '@material-ui/icons';
import * as ArchiveConstants from './renewals-archive-constants';

const today = () => moment().startOf('d');

const filterBoxes = (props) =>
  [
    {
      title: props.intl.formatMessage({
        id: 'renewed_below_MAD_or_qty_decreased'
      }),
      icon: (
        <AssignmentLate
          style={{ color: '#cb3753' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#C60C30',
      classifications: [
        ArchivedRenewalBucket.BELOW_MAD_OR_QUANTITY_DECREASED
      ]
    },
    {
      title: props.intl.formatMessage({ id: 'renewal_within_MAD' }),
      icon: (
        <Assignment
          style={{ color: '#6f95b6' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#5682a9',
      classifications: [
        ArchivedRenewalBucket.WITHIN_MAD,
        ArchivedRenewalBucket.NO_DEVIATION
      ]
    },
    {
      title: props.intl.formatMessage({ id: 'completed_last_7_days' }),
      icon: (
        <Event
          style={{ color: '#343e45' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#111c24',
      customerApproveDateAfter: today().subtract(6, 'days')
    },
    {
      title: props.intl.formatMessage({ id: 'completed_last_30_days' }),
      icon: (
        <Event
          style={{ color: '#343e45' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#111c24',
      customerApproveDateAfter: today().subtract(29, 'days')
    },
    {
      title: props.intl.formatMessage({ id: 'completed_last_90_days' }),
      icon: (
        <Event
          style={{ color: '#343e45' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#111c24',
      customerApproveDateAfter: today().subtract(89, 'days')
    },
    {
      title: props.intl.formatMessage({ id: 'completed_all_time' }),
      icon: (
        <Event
          style={{ color: '#343e45' }}
          className="icon-box-icon-image material-icons"
        />
      ),
      color: '#111c24',
      customerApproveDateAfter: ArchiveConstants.ALL_TIME_DATE
    }
  ].map((item) => ({
    ...item,
    customerApproveDateAfter: !!item.customerApproveDateAfter
      ? item.customerApproveDateAfter.format('Y-MM-DD')
      : undefined
  }));

export default filterBoxes;
